import React from 'react';
import PropTypes from 'prop-types';
import './List.css';

import useOrderBy from '../../../../hooks/useOrderBy';
import useFilters from '../../../../hooks/useFilters';

import FixedSizeList from './FixedSizeList';
import HeadersFactory from './HeadersFactory';
import Filters from '../../filters/Filters';

function ListSearchTracks({
  id, pathApi = null, title = null, width, height, size, style, type = `Full`, titleClassName = '',
  orderBy = [], filters = [], panelStyle, filtersStyle
}) {

  const { listOrderBy, getOrderByFormatted, getLocalOrderBy } = useOrderBy(orderBy, id);
  const { listFilters, getFiltersFormatted, getLocalFilters, onValidFilters, onClearFilters } = useFilters(filters);

  // FILTERS / ORDER BY AVAILABLE FOR REQUEST API - COMBINING Orderby & Filters
  let preparePathApi = ((getLocalFilters() || getLocalOrderBy())) ? `LOCAL|` + getLocalFilters() + getLocalOrderBy() : pathApi + getFiltersFormatted() + getOrderByFormatted();
  
  return (
    <div id={`ref-list`} className={`flexColumn`} style={{ ...style, height: height + 26 }}>
      { title && <span className={`type-title type-light ${titleClassName}`}>{title}</span> }

      { filters.length ? <Filters filters={listFilters} onValid={onValidFilters} height={height} onClear={onClearFilters} style={filtersStyle} panelStyle={panelStyle} /> : null }

      <HeadersFactory type={type} width={width} hasTitle={!!title} orderBy={listOrderBy} />

      <FixedSizeList
        width={width}
        isLoadMore={false}
        pathApi={preparePathApi}
        isBaseRootApi={false}
        data={[]}
        id={id}
        from={'/home'}
        rowSize={size}
        rowType={type}
        sortable={true}
        enableKeys={false}
        enableArrows={true}
        enableShortcuts={false}
        isBoost={true}
        dnd={true}
      />
    </div>
  )
}

ListSearchTracks.propTypes = {
  id: PropTypes.any.isRequired,
  pathApi: PropTypes.string,
  title: PropTypes.string,
  titleClassName: PropTypes.string,
  width: PropTypes.any.isRequired,
  height: PropTypes.any.isRequired,
  size: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
  style: PropTypes.object
}

export default ListSearchTracks;
